export default __webpack_public_path__ + "static/inter-v8-latin-variable-fa91dd85e27e102dcab0b26d1c17b466.woff2";